import { useMutation } from '@tanstack/react-query'
import api from '@/services/api'

export type WorkbookAction = 'view' | 'download'

interface TrackWorkbookActionData {
  episodeId: number
  action: WorkbookAction
  workbookUrl: string
}

export function useTrackWorkbookAction() {
  return useMutation({
    mutationFn: async ({ episodeId, action, workbookUrl }: TrackWorkbookActionData) => {
      const response = await api.post(`/episodes/${episodeId}/workbook/track`, {
        action,
        workbookUrl,
      })
      return response.data
    },
    onError: (error) => {
      // Silently fail - tracking shouldn't block user action
      console.error('Failed to track workbook action:', error)
    },
  })
}
